<template>
  <div>
    <div>
      <div>
        <h1>Languages List</h1>
        <router-link
          to="/language-add"
          class="btn-primary bg-green border-none leading-snug px-4 py-2 text-white my-2 hover:bg-green-900 no-underline rounded-full inline-block"
        >
          Add Language
        </router-link>
      </div>
      <Table :endpoint="endpoint" :tableConfig="tableConfig" />
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import Table from "@/components/DataTable/Table"

export default {
  components: { Table },
  data() {
    return {
      endpoint: `${siteConfig.siteURL}languages/`,
      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          path: "name",
        },
        {
          header: { textContent: "Id" },
          path: "id",
        },
        {
          header: { textContent: "JZ Code", sortingParam: "jz_code" },
          path: "jz_code",
        },
        {
          header: { textContent: "Option" },
          path: "id",
          type: "action",
          actionButtonText: "Edit",
          routePath: "/language-edit/:id",
        },
      ],
    }
  },
  methods: {
    deleteLanguage(language) {
      // will be used later
      this.axios({
        method: "delete",
        url: `${siteConfig.siteURL}languages/${language.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        //
      })
    },
  },
}
</script>
